import { Language, asLanguage, getDefaultLanguage } from '@rbilabs/intl';

import { FALLBACK_LANGUAGE } from 'utils/constants';
import { brand, getCountry } from 'utils/environment';

const NATIVE_LANGUAGE_NAMES: Record<Language, string> = {
  ar: 'العربية',
  ca: 'Català',
  cs: 'Čeština',
  de: 'Deutsch',
  en: 'English',
  es: 'Español',
  eu: 'Euskara',
  fr: 'Français',
  gl: 'Galego',
  it: 'Italiano',
  ko: '한국어',
  ms: 'Melayu',
  nl: 'Nederlands',
  pl: 'Polski',
  pt: 'Português',
  ro: 'Română',
  ta: 'தமிழ்',
  tl: 'ᜆᜄᜎᜓᜄ᜔',
  zh: '中文 (Zhōngwén), 汉语, 漢語',
};

/**
 * Gets a language's native name.
 *
 * @param code ISO-639-2 language code
 * @returns string
 */
export const getNativeLanguageName = (code: Language): string => {
  return NATIVE_LANGUAGE_NAMES[code] || code;
};

/**
 * Retrieves a known `Language` instance for `code`, falling back to the
 * market's default language if none can be found.
 *
 * @param code ISO-639-2 language code
 * @returns Language
 */
export const getLanguageOrDefault = (code: string): Language => {
  const defaultLanguage =
    getDefaultLanguage(brand(), getCountry().toUpperCase()) || FALLBACK_LANGUAGE;
  return asLanguage(code) || defaultLanguage;
};
